import "./App.css";
import HomeComponent from "./pages";
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import Careers from "./pages/components/Carreers";
import Policies from "./pages/components/Policies";
import Blogs from "./pages/components/Blogs";
import BlogDetail from "./pages/components/BlogDetail";


function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<HomeComponent />} />
          <Route path="/careers" element={<Careers />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:id" element={<BlogDetail />} />
          <Route path="/policies/:view" element={<Policies />} />
        </Routes>
      </Router>
      {/* <HomeComponent /> */}
    </>
  );
}

export default App;
